/**
 * 마우스휠 이벤트 방향 감지
 *
 * @param e - mouse wheel event(mousewheel DOMMouseScroll)
 * @returns {number} - Return direction(up: -1 , down: 1)
 * @example
 *
 *  $(window).on('mousewheel DOMMouseScroll', function(e){
 *      getWheelDirection(e)
 * });
 *
 */

function getWheelDirection(e){
	if(e.type == "DOMMouseScroll") return e.originalEvent.detail > 0 ? 1 : -1;
	if(e.originalEvent.wheelDeltaY) return e.originalEvent.wheelDeltaY > 0 ? -1 : 1;
	return e.originalEvent.wheelDelta > 0 ? -1 : 1;
}

/**
 * 일정시간 동안 false를 반환
 *
 * @param diffTime - 기준시간
 * @param to - true를 얻기 위한 기준시간 부터 경과 시간(1/1000 s)
 * @returns {boolean}
 */
function isPreventTime(diffTime, to = 1500){
	return (new Date().getTime() - diffTime) < to;
}

export {getWheelDirection, isPreventTime};